var _SpriteSymbol = require("/runner/_work/CertifyApp/CertifyApp/node_modules/rspack-plugin-svg-sprite/dist/runtime/symbol");
var SpriteSymbol = _SpriteSymbol.default || _SpriteSymbol;
var symbol = new SpriteSymbol({"id":"bar_chart-black","viewBox":"0 0 24 24","content":"<symbol id=\"bar_chart-black\" viewBox=\"0 0 24 24\" fill=\"black\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z\"/></symbol>"});
symbol.url = "/Scripts/dist/sprite.svg#bar_chart-black";
export default symbol;
